<template lang="pug">
  .ticker.columns.is-multiline.is-gapless
      .column.is-12.match-header(:class="[timeLevelClass]")
          .columns.is-gapless.is-mobile
              .column.columns.is-gapless.is-one-quarter-tablet.is-half-mobile
                  .column.is-2-tablet.is-3-mobile
                      a.match-link(:href="matchURL" target="_blank")
                          span.icon.is-small
                              i.fas.fa-futbol.fa-lg
                  .column
                      .tags
                          span.tag SS: {{ stat.SS }}
                          span.tag S: {{ stat.S }}
                          span.tag HT: {{ stat.HT }}
                          span.tag FT: {{ stat.FT }}
              .column.columns.is-gapless
                  .column
                      .title.is-6 {{ match.league }}
                  .column.is-one-third-tablet
                      .select
                        select(v-model="companyId")
                          option(v-for="item of companies" :value="item._id") {{ item.name }}
                      .match-time.is-flex(@click.stops="showHistory=!showHistory")
                          .title.is-5 {{ match.time }}
      .column.is-12.match-body
          .columns.is-gapless
              .column.columns.is-gapless
                  .column.columns.is-mobile
                    span {{ match.homeName }}({{ companyData.homeWinCoef }})
                    span.penalty-card.red(v-if="match.homeRedCards > 0") {{ match.homeRedCards }}
                    span.penalty-card.yellow(v-if="match.homeYellowCards > 0") {{ match.homeYellowCards }}
              .column.is-1.has-text-centered.has-text-weight-bold
                  span(
                    :class="{'has-text-danger': match.homeActive}") {{ match.homeScore }}
                  span -
                  span(
                    :class="{'has-text-danger': match.awayActive}") {{ match.awayScore }}
              .column.columns.is-gapless
                  .column.columns.is-mobile.has-text-right
                    span {{ match.awayName }}({{ companyData.awayWinCoef }})
                    span.penalty-card.red(v-if="match.awayRedCards > 0") {{ match.awayRedCards }}
                    span.penalty-card.yellow(v-if="match.awayYellowCards > 0") {{ match.awayYellowCards }}
      .column.is-12.match-footer(v-if="match.filtered.status")
          .columns
              .column.is-half-desktop.is-offset-3-desktop.columns.is-mobile
                .column.has-text-right.has-text-weight-bold {{ getCompanyName(match.filtered.companyId) }}
                .column.has-text-centered.has-text-weight-bold {{ cap(match.filtered.type) }}
                .column.is-one-fifth-desktop.has-text-centered.has-text-warning(
                  :class="[partClass(match.historySignal[0].part, 'text')]"
                  ) {{ cap(match.historySignal[0].oddsType) }} {{ match.historySignal[0].oddsType === "total" ? match.historySignal[0].move : match.historySignal[0].move === "over" ? "home" : "away" }}: {{ match.historySignal[0].total }}
                .column.has-text-left.has-text-success {{ match.historySignal[0].odds }}
      .column.is-12.match-history(v-if="showHistory")
          .columns.is-multiline
              .column.has-text-centered
                  .title.is-6 Total Signals({{ historySignal.total.length }})
                  table.table.is-striped.is-bordered.is-narrow.is-hoverable.is-fullwidth(v-if="historySignal.total.length")
                      thead
                          tr
                              th Time
                              th Type
                              th Total
                              th Odds
                      tbody
                          tr(v-for="signal of historySignal.total" :class="[partClass(signal.part)]")
                              td {{ signal.timestamp }}
                              td {{ signal.type }}
                              td {{ signal.total }} ({{ signal.move }})
                              td {{ signal.odds }}
                  .notification(v-else)
                      .content
                          p No data
              .column.has-text-centered
                  .title.is-6 Total HT({{ companyData.historyHTCount }})
                  table.table.is-striped.is-bordered.is-narrow.is-hoverable.is-fullwidth(v-if="companyData.historyHT.length")
                      thead
                          tr
                              th Time
                              th Over
                              th Total
                              th Under
                      tbody
                          tr(v-for="ht of companyData.historyHT")
                              td {{ ht.timestamp }}
                              td
                                span {{ ht.over }}
                                template(v-if="ht.diff !== 0")
                                  span.has-text-success(v-show="ht.diff < 0")
                                    span.icon
                                      i.fas.fa-arrow-down
                                    span {{ Math.abs(ht.diff).toFixed(2) }}
                                  span.has-text-danger(v-show="ht.diff > 0")
                                    span.icon
                                      i.fas.fa-arrow-up
                                    span {{ Math.abs(ht.diff).toFixed(2) }}
                              td {{ ht.total }}
                              td {{ ht.under }}
                  .notification(v-else)
                      .content
                         p No data
              .column.has-text-centered
                  .title.is-6 Total FT({{ companyData.historyFTCount }})
                  table.table.is-striped.is-bordered.is-narrow.is-hoverable.is-fullwidth(v-if="companyData.historyFT.length")
                      thead
                          tr
                              th Time
                              th Over
                              th Total
                              th Under
                      tbody
                          tr(v-for="ft of companyData.historyFT")
                              td {{ ft.timestamp }}
                              td
                                span {{ ft.over }}
                                template(v-if="ft.diff !== 0")
                                  span.has-text-success(v-show="ft.diff < 0")
                                    span.icon
                                      i.fas.fa-arrow-down
                                    span {{ Math.abs(ft.diff).toFixed(2) }}
                                  span.has-text-danger(v-show="ft.diff > 0")
                                    span.icon
                                      i.fas.fa-arrow-up
                                    span {{ Math.abs(ft.diff).toFixed(2) }}
                              td {{ ft.total }}
                              td {{ ft.under }}
                  .notification(v-else)
                      .content
                          p No data
          .columns.is-multiline
            .column.has-text-centered
              .title.is-6 Hdp Signals({{ historySignal.hdp.length }})
              table.table.is-striped.is-bordered.is-narrow.is-hoverable.is-fullwidth(v-if="historySignal.hdp.length")
                thead
                  tr
                    th Time
                    th Type
                    th Hdp
                    th Odds
                tbody
                  tr(v-for="signal of historySignal.hdp" :class="[partClass(signal.part)]")
                    td {{ signal.timestamp }}
                    td {{ signal.type }}
                    td {{ signal.total }} ({{ signal.move === "over" ? "home" : "away" }})
                    td {{ signal.odds }}
              .notification(v-else)
                .content
                  p No data
            .column.has-text-centered
              .title.is-6 Hdp HT({{ companyData.historyHThdpCount }})
              table.table.is-striped.is-bordered.is-narrow.is-hoverable.is-fullwidth(v-if="companyData.historyHThdp.length")
                thead
                  tr
                    th Time
                    th Home
                    th Hdp
                    th Away
                tbody
                  tr(v-for="ht of companyData.historyHThdp")
                    td {{ ht.timestamp }}
                    td
                      span {{ ht.over }}
                      template(v-if="ht.diff !== 0")
                        span.has-text-success(v-show="ht.diff < 0")
                          span.icon
                            i.fas.fa-arrow-down
                          span {{ Math.abs(ht.diff).toFixed(2) }}
                        span.has-text-danger(v-show="ht.diff > 0")
                          span.icon
                            i.fas.fa-arrow-up
                          span {{ Math.abs(ht.diff).toFixed(2) }}
                    td {{ ht.total }}
                    td {{ ht.under }}
              .notification(v-else)
                .content
                  p No data
            .column.has-text-centered
              .title.is-6 Hdp FT({{ companyData.historyFThdpCount }})
              table.table.is-striped.is-bordered.is-narrow.is-hoverable.is-fullwidth(v-if="companyData.historyFThdp.length")
                thead
                  tr
                    th Time
                    th Home
                    th Hdp
                    th Away
                tbody
                  tr(v-for="ft of companyData.historyFThdp")
                    td {{ ft.timestamp }}
                    td
                      span {{ ft.over }}
                      template(v-if="ft.diff !== 0")
                        span.has-text-success(v-show="ft.diff < 0")
                          span.icon
                            i.fas.fa-arrow-down
                          span {{ Math.abs(ft.diff).toFixed(2) }}
                        span.has-text-danger(v-show="ft.diff > 0")
                          span.icon
                            i.fas.fa-arrow-up
                          span {{ Math.abs(ft.diff).toFixed(2) }}
                    td {{ ft.total }}
                    td {{ ft.under }}
              .notification(v-else)
                .content
                  p No data
</template>

<script>
export default {
  name: "TickerMatch",
  props: {
    match: Object,
    source: Object,
    active: Number
  },
  data: () => ({
    showHistory: false,
    companyId: false
  }),
  watch: {
    companyData() {
      if (this.companyData && this.companyData.companyId && !this.companyId) {
        this.setCompanyId(+this.companyData.companyId);
      }
    },
    "match.filtered"(n) {
      if (n.companyId && n.status) {
        this.setCompanyId(n.companyId);
      }
    },
    companyIdFilter(n) {
      if (n.length === 0) {
        this.setCompanyId(false);
        return this.resetCompany();
      }
      if (n.length === 1) {
        const [cid] = n;
        this.setCompanyId(cid);
      }
    },
    signalFilter() {
      const c = this.$store.state.ticker.filters.companies;
      if (c.length === 1) this.setCompanyId(+c[0]);
    }
  },
  computed: {
    companyIdFilter() {
      return this.$store.state.ticker.filters.companies;
    },
    signalFilter() {
      return this.$store.state.ticker.filters.signals;
    },
    companies() {
      const companies = this.match.data.map(({ companyId }) => companyId);
      return this.$store.state.company.list.filter(row =>
        companies.includes(row.id)
      );
    },
    companySignals() {
      return this.match.historySignal.filter(
        ({ companyId }) => +companyId === +this.companyId
      );
    },
    historySignal() {
      return this.companySignals.reduce(
        (acc, row) => ({
          ...acc,
          [row.oddsType || "total"]: [...acc[row.oddsType || "total"], row]
        }),
        { total: [], hdp: [] }
      );
    },
    companyData() {
      const defaultData = {
        companyId: 0,
        homeWinCoef: 0,
        awayWinCoef: 0,
        historyHThdp: [],
        historyFThdp: [],
        historyHT: [],
        historyFT: []
      };
      const result =
        this.match.data.find(
          ({ companyId }) => +companyId === +this.companyId
        ) ||
        this.match.data[0] ||
        defaultData;
      Object.keys(defaultData).forEach(key => {
        if (!(key in result)) result[key] = defaultData[key];
      });
      return result;
    },
    settings() {
      return [...this.$store.state.data.settings].map(item => {
        let result = { ...item };
        const active =
          result.settings.find(s => s.status) || result.settings[0];
        // eslint-disable-next-line fp/no-mutation
        result.settings = active.settings;
        return result;
      });
    },
    stat() {
      const partGroup = this.companySignals.reduce(
        (acc, { part }) => ({ ...acc, [part]: acc[part] + 1 }),
        { HT: 0, FT: 0 }
      );
      return {
        SS: this.match.historySignal.length,
        S: this.companySignals.length,
        HT: partGroup.HT,
        FT: partGroup.FT
      };
    },
    matchURL() {
      const u = new URL(this.source.url);
      return `${u.origin}/3in1odds/${this.match._id}/`;
    },
    timeLevelClass() {
      const timeLevel = this.match.time < 45 ? 1 : 2;
      switch (timeLevel) {
        case 1:
          return "has-background-primary";
        case 2:
          return "has-background-warning";
        default:
          return "";
      }
    }
  },
  methods: {
    setCompanyId(cid) {
      const company = this.companies.find(row => row.id === cid);
      if (company || cid === false) this.companyId = cid;
    },
    getCompanyName(id) {
      const company = this.companies.find(c => c.id === id);
      return company ? company.name : "CompanyName";
    },
    partClass(part, type = "background") {
      if (!["HT", "FT"].includes(part)) return "";
      return `has-${type}-${part === "HT" ? "success" : "warning"}`;
    },
    cap(str) {
      if (!str || !str.length) return "Sharp";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    resetCompany() {
      if (this.companyId === false && this.companyIdFilter.length === 1) {
        this.setCompanyId(this.companyIdFilter[0]);
      }
      if (this.companyId === false && this.companies.length) {
        this.setCompanyId(this.companies[0].id);
      }
    }
  },
  mounted() {
    this.resetCompany();
  }
};
</script>

<style lang="scss" scoped>
.ticker {
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;

  &.is-active {
    .match-header {
      .match-link {
        animation: rotate 3s infinite;
      }
    }
  }

  .match-header {
    color: #000;
    background: #d7d7d7;
    transition: all 0.3s linear;

    & > .columns {
      & > .column {
        &:first-child {
          display: flex;
          align-items: center;
          padding-left: 0.3rem !important;
        }

        &.columns {
          margin: 0 !important;
        }

        &:last-child {
          align-items: center;
          @media screen and (max-width: $tablet) {
            flex: 1;

            .column {
              &:first-child {
                justify-content: flex-end !important;

                .title {
                  padding: 0 1rem;
                  font-size: 0.9rem;
                  line-height: 1.5rem !important;
                  font-weight: normal;
                  text-align: right;
                }
              }

              &:last-child {
                .match-time {
                  .title {
                    font-size: 1.2rem;
                    padding-bottom: 0.2rem;
                    font-weight: bold;
                  }
                }
              }
            }
          }

          .column {
            display: flex;
            &:first-child {
              justify-content: center;

              .title {
                line-height: 2rem;
              }
            }

            &:last-child {
              justify-content: flex-end;
              position: relative;

              .select {
                display: flex;
                align-items: center;

                select {
                  font-size: 0.8em;
                  &:not([multiple]) {
                    padding-right: 1.5em;
                  }
                }

                &:not(.is-multiple) {
                  height: 2em;
                }
              }

              .select:not(.is-multiple):not(.is-loading)::after {
                right: 0.6em;
                width: 0.425em;
                height: 0.425em;
                margin-top: -0.2375em;
              }

              .match-time {
                display: flex;
                align-items: center;
                width: 3.15em;
                cursor: pointer;
                padding: 0 0.7rem;
                .title {
                  opacity: 0.8;

                  &::after {
                    content: "'";
                    animation: blink 1s infinite;
                  }
                }
              }
            }
          }
        }
      }
    }

    .match-link,
    .title {
      color: #000;
    }

    .match-link {
      display: inline-flex;
      padding: 0.5rem;
      border-radius: 50%;
      background-color: transparent;
      transition: all 0.2s linear;

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }

  .match-body {
    color: #fff;
    background: #283238;
    transition: all 0.3s linear;

    .columns {
      align-items: center;

      .has-text-right {
        flex-direction: row-reverse;
      }
    }

    & > .columns {
      .is-gapless:not(:last-child) {
        margin-bottom: 0;
      }

      & > .column {
        & > span.is-active {
          text-shadow: 1px -1px #ff3860, -1px 1px #ff3860, -1px 0px #ff3860,
            0 1px #ff3860, 1px 0 #ff3860, 0 -1px #ff3860;
        }
        &.team-level-1 {
          background: #00bb8a;
        }
        &.team-level-2 {
          background: #ffdd57;
          color: #000;
        }
        &.team-level-3 {
          background: #d33254;
        }
        & > .column {
          flex: 1;
          &:first-child {
            flex: 5;
            padding: 0 0.3rem !important;
          }
        }
      }

      .penalty-card {
        font-size: 1rem;
        border-radius: 3px;
        height: 1.3rem;
        width: 1.1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $defaultColor;

        &.yellow {
          background-color: yellow;
          color: $cardFontColor;
        }
        &.red {
          background-color: red;
        }
      }
    }
  }

  .match-history {
    border-top: 1px solid #fff;
    padding-top: 1rem !important;
  }

  .penalty-card {
    font-size: 1rem;
    border-radius: 3px;
    height: 1.3rem;
    width: 1.1rem;
    display: inline-block;
    text-align: center;
    color: $defaultColor;

    &.yellow {
      background-color: yellow;
      color: $cardFontColor;
    }
    &.red {
      background-color: red;
    }
  }
}

@keyframes blink {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
